export const blockIconsAndroidDarkModeNew = (
	<span className='material-symbols-outlined'>dark_mode</span>
);
